import React, { useState } from 'react'
import WriterAddForm from '@Components/WorkRegistrationSubs/AddWriter/WriterAddForm'
import WriterCreateForm from '@Components/WorkRegistrationSubs/AddWriter/WriterCreateForm'
import { WriterFormType } from '@App/enum/writer-form-type'
import { WriterModel } from '@Entities/work/writer-model'

interface AddWriterFormFlowProps {
    setFoundWriterToDraft: (writer: WriterModel, closePopup: boolean) => Promise<void>
    addWriterToDraft: (closePopup: boolean) => void
    writerData: WriterModel
    setWriterData: (writerData: WriterModel) => void
}

const AddWriterFormFlow = ({
    setFoundWriterToDraft,
    addWriterToDraft,
    writerData,
    setWriterData,
}: AddWriterFormFlowProps) => {
    const [writeFormType, setWriteFormType] = useState<WriterFormType>(WriterFormType.add)

    return (
        <div>
            <WriterAddForm
                setFoundWriterToDraft={setFoundWriterToDraft}
                onRadioButtonClicked={() => {
                    setWriteFormType(WriterFormType.add)
                }}
                expanded={writeFormType === WriterFormType.add}
                expandedChanged={(formType) => {
                    setWriteFormType(formType)
                }}
            />

            <WriterCreateForm
                writerData={writerData}
                setWriterData={setWriterData}
                addWriterToDraft={addWriterToDraft}
                onRadioButtonClicked={() => {
                    setWriteFormType(WriterFormType.create)
                }}
                setFoundWriterToDraft={setFoundWriterToDraft}
                expanded={writeFormType === WriterFormType.create}
            />
        </div>
    )
}

export default AddWriterFormFlow
